import React from "react";
import Box from "@mui/material/Box";
import logo from "../../assets/brand/Logo-text.svg";
import { DRAG_TOOLBAR_HEIGHT } from "../constants";
import { ROUTES } from "../../constants/routes";

const CreateVideoLogo = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: DRAG_TOOLBAR_HEIGHT,
        display: "flex",
        alignItems: "center",
        px: 2,
        zIndex: 1400,
      }}
    >
      <img
        src={logo}
        alt="CherryClipz"
        title="Open My Library in a new tab (keeps this project open)"
        onClick={() => window.open(ROUTES.MY_LIBRARY, "_blank", "noopener")}
        style={{ height: 36, width: "auto", cursor: "pointer" }}
      />
    </Box>
  );
};

export default CreateVideoLogo;
